import { updatedDiff } from '@helpers/data';

import { WithdrawalsSetPaymentSystemStateReducer } from './types';

export const withdrawalsSetPaymentSystemStateReducer: WithdrawalsSetPaymentSystemStateReducer =
  (state, action) => {
    const { aggregatorId, paymentSystemId, paymentSystemState } =
      action.payload;

    if (
      !paymentSystemId ||
      !state.withdrawalsDistributionSettingsItems ||
      !state.withdrawalsDistributionSettingsProcessedItems
    ) {
      return state;
    }

    const processed = {
      ...state.withdrawalsDistributionSettingsProcessedItems,
      [aggregatorId]: {
        ...state.withdrawalsDistributionSettingsProcessedItems[aggregatorId],
        paymentSystems: {
          ...state.withdrawalsDistributionSettingsProcessedItems[aggregatorId]
            ?.paymentSystems,
          [paymentSystemId]: {
            ...(state.withdrawalsDistributionSettingsProcessedItems[
              aggregatorId
            ]?.paymentSystems
              ? state.withdrawalsDistributionSettingsProcessedItems[
                  aggregatorId
                ]?.paymentSystems[paymentSystemId]
              : {}),
            paymentSystemState,
          },
        },
      },
    };

    const changes = updatedDiff(
      state.withdrawalsDistributionSettingsItems,
      processed
    );

    return {
      ...state,
      withdrawalsDistributionSettingsProcessedItems: {
        ...changes,
      },
    };
  };
